import Menu from '@/components/menu/component'
import Notice from '@/components/notice/component'
import Foot from '@/components/foot/component'

export default {
  name: 'header-layout',
  props: {
    background: {
      type: String,
      default: ''
    }
  },
  components: { Menu, Notice, Foot }
}



// WEBPACK FOOTER //
// ./src/layouts/header/script.js